export default __webpack_public_path__ + "bacc2b034d1a58de3b5b096079e33013.png";